const usePushState = function (opts) {
  if (!opts.pushState) {
    return false;
  }
  return (
    (window.history != null ? window.history.pushState : undefined) != null
  );
};

module.exports = {
  update(adjustedURL, opts) {
    if (opts == null) {
      opts = {};
    }
    if (usePushState(opts)) {
      return window.history.pushState(null, null, adjustedURL);
    } else if (
      (window.history != null ? window.history.replaceState : undefined) != null
    ) {
      return window.history.replaceState(null, null, adjustedURL);
    } else {
      return (window.location = adjustedURL);
    }
  },
};
